// Might need this for test harnesses...
// const L = (window['L'] || import('leaflet'));

export default class AbstractLayerManager {
	constructor(myKey, instance) {
		this.inst = instance;
		this.id = myKey;
		this.name = "";
		this.popupName = "";
		this.options = {};
		this.options.hasPanRefresh = true;
		this.options.hasAutoRefresh = true;
		this.layer = null;
		this.tasks = {};
	}
	
	attachLayer() {
		if(this.isAttached()) return true;
		// Wire up to parent instance
		this.inst.layers[this.id] = this.layer = new L.LayerGroup();
		this.inst.map.addLayer(this.layer);
		if(this.options.hasPanRefresh) this.inst.mapMoveListeners[this.id] = this.id;
		if(this.options.hasAutoRefresh) this.inst.autoUpdateListeners[this.id] = this.id;
		this.refreshLayer();
	}
	
	detachLayer() {
		if(!this.isAttached()) return true;
		if(this.options.hasPanRefresh) delete(this.inst.mapMoveListeners[this.id]);
		if(this.options.hasAutoRefresh) delete(this.inst.autoUpdateListeners[this.id]);
		this.inst.map.removeLayer(this.layer);
		delete(this.inst.layers[this.id]);
		// TODO Before null layer, should cancel all this.tasks
		this.layer = null;
	}

	// does this Manager have layer(s) attached to map?
	// return bool
	isAttached() {
		return (this.layer !== null && this.inst.layers[this.id] && this.inst.layers[this.id] === this.layer);
	}

	isVisible() {
		return (this.layer !== null && this.inst.map.hasLayer(this.layer));
	}

	toggleLayer(active) {
		if(active && !this.isAttached()) {
			this.attachLayer();
		} else if(!active && this.isAttached()) {
			this.detachLayer();
		}
	}

	hideLayer() {
		this.inst.map.removeLayer(this.layer);
	}

	showLayer() {
		this.inst.map.addLayer(this.layer);
	}

	refreshLayer() {
		// Stub that gets overridden in child class
	}
}